import LockTableCellRenderer from "./LockTableCellRenderer";

export default class DateCellRenderer extends LockTableCellRenderer {
    constructor(weekDayNames) {
        super();
        this.weekDayNames = weekDayNames;
    }

    generateContent(cell) {
        let dateInfo = cell.getValue();
        cell.getCellEl().innerHTML = '<div class="columnWidthStrut"></div>' +
                                     this.weekDayNames[dateInfo.date.getDay()] + '<br/>' + dateInfo.date.getDate();
    }

    getCellClassName(cell) {
        let result = ["dateCell"];

        if (cell.getRow().isViewerTodayCell(cell))
            result.push("Today");

        if (this.isSelected(cell))
            result.push("Selected");
        else if (this.isHovered(cell))
            result.push("Hovered");
        else {
            if (!cell.getValue().working)
                result.push("Non");
            result.push("Working");

            if (this.isColumnIncludedIntoSelection(cell))
                result.push("MarkSelection");
        }

        return result.join("");
    }

    getLastCellRightBorderClassName() {
        return "lockTableLightRightBorder";
    }

    isColumnIncludedIntoSelection(cell) {
        return this.getSelectionController(cell).isColumnIncludedIntoSelection(cell.getColIdx());
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/renderers/DateCellRenderer.js